// extracted by mini-css-extract-plugin
module.exports = {"root":"PlannerStatChip_root__xG7LQ","value":"PlannerStatChip_value__b7_vk","label":"PlannerStatChip_label__yQ3pL","progressDial":"PlannerStatChip_progressDial__d8T3X"};